import React from 'react'
// components
import Locations from 'components/PageComponents/Settings/Locations'
import LocationsAPI from 'containers/Locations/layers/API'

const LocationsContainer: React.FC = () => {
  return (
    <LocationsAPI>
      <Locations />
    </LocationsAPI>
  )
}

export default LocationsContainer
